// extracted by mini-css-extract-plugin
export default {"root":"Counter_root__0p0Oo","regular":"Counter_regular__bHt2-","black":"Counter_black__szYFK","active":"Counter_active__cawST"};